<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic" >Version Change</h4>

          <el-form :model="From" 
            ref="From" 
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="small"
          >
            <el-form-item label="Version Change :" prop="versionchange">
                <el-select v-model="From.versionchange" placeholder="Please select" style="width: 100%">
                     <el-option label="Pure AP Version" value="0"></el-option>
                     <el-option label="ONU+AP Version" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="save">Apply</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      From: {
        versionchange: "0"
      }
    };
  },
  methods: {
    init() {
      let getData = {
        CmdType: "GET_VERSION"
      };
      axios.post("/boafrm/fhVersionChange", getData).then(res => {
        let data = res.data;
        if (data.ret == "0") {
            this.From.versionchange = data.version;
        } else {
          this.$message.error("Data acquisition error！");
        }
      });
    },
    save() {
      var postDta = {
        CmdType: "SET_VERSION",
        version: this.From.versionchange,
      };
      axios.post("/boafrm/fhVersionChange", postDta).then(res => {
        var data = res.data;
        if (data && data != "") {
            this.$message.success("Configuration Successful！");
        } else {
            this.$message.error("Data acquisition error！");
        }
      });
    }
  },
  created() {
    this.init();
  }
};
</script>
